import React from 'react';

import {useFinancialSupport} from 'presentation/pages/private/hooks/useFinancialSupport';
import {HelpPageTaggingEnum} from 'main/analytics/gaTagsEnum';
import {ChannelAccordion} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelAccordion';
import {ChannelPhone} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelPhone';
import {FinancialSupportAccordionProps} from './types';

export function FinancialSupportAccordion({
	title,
	expandedState,
	handleAccordionToggle,
	phone,
}: FinancialSupportAccordionProps) {
	const {canShowFinancialSupport, financialSupportPhone} = useFinancialSupport();

	if (!canShowFinancialSupport) return null;

	return (
		<ChannelAccordion
			dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_ATENDIMENTO_FINANCEIRO_AJUDA}
			title={title}
			handleAccordionToggle={handleAccordionToggle}
			expandedState={expandedState}>
			<ChannelPhone value={phone ?? financialSupportPhone} />
		</ChannelAccordion>
	);
}
